import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import _sortBy from 'lodash/sortBy';
import TextField from '../../../common/TextField';
import Select from '../../../common/Select';
import _get from 'lodash/get';
import { getTextFromLanguage } from '../../../../helper/languageHelper';
const uuidv4 = require('uuid/v4');
const omitDeep = require('omit-deep');
const TeamstoreIntroductionText = ({
  classes,
  languages,
  teamstore,
  teamstoreId,
  updateTeamstore
}) => {
  const introductionTextId =
    teamstore.introductionText && teamstore.introductionText.id
      ? teamstore.introductionText.id
      : uuidv4();
  return (
    <Grid container>
      {languages.map((language, index) => {
        var introductionText = '';
        try {
          introductionText = getTextFromLanguage(
            teamstore.introductionText.text,
            language
          );
        } catch (error) {}
        return (
          <Grid
            container
            key={'style-introductionText-' + index}
            direction="row"
            alignItems="flex-end"
            spacing={1}
            className={classes.container}
          >
            <Grid item xs={10}>
              <TextField
                label="Introduction text"
                placeholder="Enter text"
                multiline={true}
                rowsMax="15"
                value={introductionText}
                onChange={e => {
                  updateTeamstore({
                    optimisticResponse: {
                      __typename: 'Mutation',
                      updateTeamstore: {
                        ...teamstore,
                        introductionText: {
                          id: introductionTextId,
                          text: [
                            ...languages.map((tempLanguage, index) => {
                              return {
                                langCode: tempLanguage,
                                content:
                                  tempLanguage === language
                                    ? e.target.value
                                    : getTextFromLanguage(
                                        teamstore.introductionText.text,
                                        tempLanguage
                                      ),
                                __typename: 'TextContent'
                              };
                            })
                          ],
                          __typename: 'Text'
                        }
                      }
                    },
                    variables: {
                      id: teamstoreId,
                      input: {
                        introductionText: {
                          id: introductionTextId,
                          text: [
                            ...languages.map((tempLanguage, index) => {
                              return {
                                langCode: tempLanguage,
                                content:
                                  tempLanguage === language
                                    ? e.target.value
                                    : getTextFromLanguage(
                                        teamstore.introductionText.text,
                                        tempLanguage
                                      )
                              };
                            })
                          ]
                        }
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Grid
                container
                alignItems="center"
                justify="center"
                style={{
                  height: 38,
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: '3px'
                }}
              >
                <Typography variant="body1">{language}</Typography>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TeamstoreIntroductionText;
